export const toolbar_menu = [{
  title: 'FISS Department',
  link: '/FISSD'
},
/*{
  title: 'Partners',
  link: '/partners'
},*/
{
  title: 'License Renewal',
  link: '//license-renewal.domain.nfmp.gov.ng'
},
/*{
  title: 'Products',
  link: '/products'
},
{
  title: 'Dealers Listing',
  link: '/dealersListing'
},
{
  title: 'Import/Export Hub',
  link: '//import-export.domain.nfmp.gov.ng'
},
{
  title: 'iFarmers Platform',
  link: '/farmers',
  link2: '//farmers-platform.domain.nfmp.gov.ng'
},*/
{
  title: 'Guidelines',
  link: '/guidelines'
},
{
  title: 'Create Account',
  link: '/signup'
},
{
  title: 'Account Login',
  link: '//members-portal.domain.nfmp.gov.ng'
}
]
export default {
  toolbar_menu
}
